"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deepEquals = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _misc = require("./misc");

// This deepEqual is only designed to handle objects containing object literals,
// arrays and primitive values.
// This function does not deal with arrays of like objects, where these arrays do
// not have matching sort order
// Ideally we would use an existing NPM package to do this, but none that I tried would
// play nicely with TS, build process and unit tests.  PRs to remedy this are welcome.
var deepEquals = function deepEquals(val1, val2) {
  if (val1 === val2) {
    return true;
  } else if ((0, _misc.isObject)(val1)) {
    if (!(0, _misc.isObject)(val2)) {
      return false;
    } else {
      var obj1Entries = Object.entries(val1);

      if (obj1Entries.length !== Object.keys(val2).length) {
        return false;
      }

      return obj1Entries.reduce(function (isEqual, _ref) {
        var _ref2 = (0, _slicedToArray2["default"])(_ref, 2),
            key = _ref2[0],
            v1 = _ref2[1];

        if (isEqual === false) {
          return isEqual;
        }

        var v2 = val2[key];
        return deepEquals(v1, v2);
      }, true);
    }
  } else if (Array.isArray(val1)) {
    if (!Array.isArray(val2) || val1.length !== val2.length) {
      return false;
    } else {
      var val2Sorted = val2.sort(function (x, y) {
        return x < y ? -1 : 1;
      }); // Return false if any index is unequal:

      return !val1.sort(function (x, y) {
        return x < y ? -1 : 1;
      }).some(function (v1, i) {
        var v2 = val2Sorted[i];
        return deepEquals(v1, v2) === false;
      });
    }
  } else {
    return false;
  }
};

exports.deepEquals = deepEquals;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/rio-sdk-web/dist/cjs/utils/simpleDeepEqual.js
// module id = 3442
// module chunks = 11